export default __webpack_public_path__ + "static/media/816.4665e2be.jpg";